import { BASE_URL } from '../services/ApiService/ApiConfig';
import { tokenActual } from '../seguridad/sesionCliente';

const RAIZ = `${BASE_URL}/poligrafia`;

export async function poli(ruta, metodo = 'GET', cuerpo) {
    const res = await fetch(`${RAIZ}${ruta}`, {
        method: metodo,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenActual()}` },
        body: cuerpo === undefined ? undefined : JSON.stringify(cuerpo)
    });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(datos.mensaje || `Error ${res.status}`);
    return datos;
}

export const qs = (o) => new URLSearchParams(Object.entries(o).filter(([, v]) => v !== '' && v != null)).toString();

export const fechaHora = (v) => (v ? new Date(v).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' }) : '');
export const soloFecha = (v) => (v ? new Date(v).toLocaleDateString('es-EC') : '');
export const hora = (v) => (v ? new Date(v).toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' }) : '');

/** "2026-10-17T09:30" en hora local, para un input datetime-local. */
export const aInputFechaHora = (d) => {
    const z = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(d.getHours())}:${z(d.getMinutes())}`;
};

export const NOMBRE_TIPO = {
    TIPO_PRUEBA: 'Tipos de prueba',
    MOTIVO: 'Motivos de solicitud',
    MOTIVO_ANULACION: 'Motivos de anulacion',
    PUESTO: 'Puestos (por compania)',
    CIUDAD: 'Ciudades',
    FOTO: 'Fotos requeridas en Recepcion',
    PREGUNTA: 'Banco de preguntas'
};

/** Cedula ecuatoriana (misma regla que CedulaEcuador.java): solo para avisar mientras se escribe. */
export function cedulaValida(c) {
    if (!/^\d{10}$/.test(c || '')) return false;
    const prov = Number(c.slice(0, 2));
    if (!((prov >= 1 && prov <= 24) || prov === 30) || Number(c[2]) >= 6) return false;
    let s = 0;
    for (let i = 0; i < 9; i++) {
        let d = Number(c[i]) * (i % 2 === 0 ? 2 : 1);
        s += d > 9 ? d - 9 : d;
    }
    return (10 - (s % 10)) % 10 === Number(c[9]);
}

export const EstadoTag = ({ fila }) => (
    <span style={{ background: fila.estado_color, color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: '.8rem', whiteSpace: 'nowrap' }}>
        {fila.estado_nombre}
    </span>
);

/** Sube un archivo (multipart). El backend lo cifra antes de guardarlo. */
export async function subirArchivo(pruebaId, archivo, tipo, etiqueta) {
    const fd = new FormData();
    fd.append('archivo', archivo);
    fd.append('tipo', tipo);
    if (etiqueta) fd.append('etiqueta', etiqueta);
    const res = await fetch(`${RAIZ}/pruebas/${pruebaId}/archivos`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${tokenActual()}` },
        body: fd
    });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(datos.mensaje || `Error ${res.status}`);
    return datos;
}

/** Trae el archivo descifrado y devuelve una URL local (blob) que solo vive en esta pestana. */
export async function urlArchivo(archivoId) {
    const res = await fetch(`${RAIZ}/archivos/${archivoId}`, { headers: { Authorization: `Bearer ${tokenActual()}` } });
    if (!res.ok) {
        const datos = await res.json().catch(() => ({}));
        throw new Error(datos.mensaje || `Error ${res.status}`);
    }
    return URL.createObjectURL(await res.blob());
}

export const TEMAS_ENTREVISTA = [
    { clave: 'medica', titulo: 'Historia medica' },
    { clave: 'familiar', titulo: 'Historia familiar' },
    { clave: 'financiera', titulo: 'Historia financiera' },
    { clave: 'laboral', titulo: 'Historia laboral' },
    { clave: 'alcohol', titulo: 'Consumo de alcohol' },
    { clave: 'drogas', titulo: 'Consumo de drogas ilicitas' },
    { clave: 'judicial', titulo: 'Antecedentes judiciales' },
    { clave: 'vinculos', titulo: 'Vinculos con personas al margen de la ley' }
];

/** Descarga el PDF del informe (con la marca de agua de quien descarga). */
export async function descargarInforme(pruebaId, codigo) {
    const res = await fetch(`${RAIZ}/pruebas/${pruebaId}/informe/pdf`, { headers: { Authorization: `Bearer ${tokenActual()}` } });
    if (!res.ok) {
        const datos = await res.json().catch(() => ({}));
        throw new Error(datos.mensaje || `Error ${res.status}`);
    }
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement('a');
    a.href = url;
    a.download = `Informe ${codigo || pruebaId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
}

/** Parametros del enlace del correo: #/poligrafia/solicitudes?prueba=12 o ?solicitud=SOL-... */
export function parametrosEnlace() {
    const h = window.location.hash || '';
    const i = h.indexOf('?');
    return i < 0 ? new URLSearchParams() : new URLSearchParams(h.slice(i + 1));
}
